import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Loader } from "@revvsales/components";
import DocumentReviewClauseTag from "./DocumentReviewClauseTag";
import DocumentReviewClausesFilter from "./DocumentReviewClausesFilter";

import emptyImage from "../../../../assets/empty-meta-tags.png";
import { EVENT_NAMES } from "../../../../constants/events";

import { amplitudeLogEvent } from "../../../../utils/amplitudeUtils";
// Actions
import {
  getClauseAnalysisMeta,
  getDocAnalysis,
} from "../../../../actions/MetalensActions/metalensActions";

const DocumentReviewClauses = ({
  active,
  clauseType,
  goBack,
  perDepartmentAnalysisIndex,
  fullAnalysis,
  perClauseAnalysisIndex,
  docID,
  sharingHash,
  getClauseAnalysisMetaAction,
  departmentClauseMapping,
  clauseDepartmentMapping,
  getDocAnalysisAction,
  isLatestAnalysis,
}) => {
  const [activeAnalysisIndex, setActiveAnalysisIndex] = useState(0);
  const [currentAnalysis, setCurrentAnalysis] = useState([]);
  const [filterModalActive, setFilterModalActive] = useState(false);
  const [originalAnalysis, setOriginalAnalysis] = useState([]);
  const [currentFilter, setCurrentFilter] = useState([]);
  const [reAnalyseLoader, setReAnalyseLoader] = useState(false);

  useEffect(
    () => {
      const getDocumentReviewClauses = () => {
        if (
          perDepartmentAnalysisIndex &&
          perDepartmentAnalysisIndex[clauseType.department]
        ) {
          return perDepartmentAnalysisIndex[clauseType.department];
        }
        if (fullAnalysis && clauseType.department === "Full") {
          return fullAnalysis.map((item, i) => i);
        }
        return [];
      };
      if (clauseType.id) {
        setActiveAnalysisIndex(0);
        const initialAnalysis = getDocumentReviewClauses();
        setCurrentAnalysis(initialAnalysis);
        setOriginalAnalysis(initialAnalysis);
      }
    },
    [
      clauseType.department,
      clauseType.id,
      fullAnalysis,
      perDepartmentAnalysisIndex,
    ],
  );

  useEffect(
    () => {
      getClauseAnalysisMetaAction().catch(() => {});
    },
    [getClauseAnalysisMetaAction],
  );

  useEffect(
    () => {
      if (departmentClauseMapping && clauseType && clauseType.department) {
        if (clauseType.department === "Full" && clauseDepartmentMapping) {
          const complete = [];
          Object.keys(clauseDepartmentMapping).forEach(nc => {
            complete.push(nc);
          });
          setCurrentFilter(complete);
        } else if (departmentClauseMapping[clauseType.department]) {
          setCurrentFilter(departmentClauseMapping[clauseType.department]);
        }
      }
    },
    [clauseType, departmentClauseMapping, clauseDepartmentMapping],
  );

  const _applyFilters = newFilters => {
    const newAnalysis = [];
    let newFilterList = [...currentFilter];
    newFilters.forEach(nf => {
      if (nf.status) {
        for (let index = 0; index < fullAnalysis.length; index += 1) {
          const element = fullAnalysis[index];
          const foundElement = element.tags.find(
            item => item.tag === nf.clause,
          );
          if (foundElement) {
            if (newAnalysis.indexOf(index) === -1) {
              newAnalysis.push(index);
            }
          }
        }
        if (newFilterList.indexOf(nf.clause) === -1) {
          newFilterList.push(nf.clause);
        }
      } else if (newFilterList.indexOf(nf.clause) !== -1) {
        newFilterList = newFilterList.filter(c => c !== nf.clause);
      }
    });
    // Amplitude
    amplitudeLogEvent(EVENT_NAMES.CLAUSE_ANALYSIS_CLAUSE_FILTER_SELECTED, {
      OldFilter: currentFilter,
      NewFilter: newFilterList,
    });
    setCurrentFilter(newFilterList);
    setCurrentAnalysis(newAnalysis);
  };

  const _getNewFilters = () => {
    if (perClauseAnalysisIndex && currentAnalysis) {
      const newFilters = [];
      Object.keys(perClauseAnalysisIndex).forEach(type => {
        const newFilter = {
          id: type,
          status: false,
          clause: type,
        };

        if (currentFilter.indexOf(type) > -1) {
          newFilter.status = true;
        }
        newFilters.push(newFilter);
      });
      return newFilters;
    }
    return [];
  };

  const _resetAnalysis = () => {
    setCurrentAnalysis(originalAnalysis);
    if (departmentClauseMapping && clauseType && clauseType.department) {
      if (clauseType.department === "Full" && clauseDepartmentMapping) {
        const complete = [];
        Object.keys(clauseDepartmentMapping).forEach(nc => {
          complete.push(nc);
        });
        setCurrentFilter(complete);
      } else if (departmentClauseMapping[clauseType.department]) {
        setCurrentFilter(departmentClauseMapping[clauseType.department]);
      }
    }
    setFilterModalActive(false);
    // Amplitude
    amplitudeLogEvent(EVENT_NAMES.CLAUSE_ANALYSIS_RESET_FILTER, {
      ReviewType: clauseType.department,
    });
  };

  return (
    <div
      className={`documentreviewclauses animated fadeinright ${
        active ? "" : "documentreviewsection-inactive"
      }`}>
      <div className="documentreviewclauses-head">
        <div>
          <span
            onClick={goBack}
            role="button"
            onKeyDown={() => {}}
            tabIndex="0"
            className="documentreviewclauses-head-back-icon">
            <FontAwesomeIcon icon={["far", "angle-left"]} className="" />
          </span>
          <span>{clauseType.title}</span>
          <span className="metalens-tags-head-total">
            {currentAnalysis.length}
          </span>
        </div>
        <div
          onClick={() => {
            setFilterModalActive(true);
          }}
          role="button"
          onKeyDown={() => {}}
          tabIndex="0"
          className="documentreviewclauses-filter-action">
          <FontAwesomeIcon icon={["fas", "filter"]} className="" />
          {perClauseAnalysisIndex && currentAnalysis && (
            <span className="documentreviewclauses-filter-pill">
              {_getNewFilters().filter(nf => nf.status).length} clauses
            </span>
          )}
        </div>
      </div>
      <div className="documentreviewclauses-head-description">
        {clauseType.description}
      </div>
      {/* Reanalyse */}
      {!isLatestAnalysis && (
        <div className="metalens-detect-action documentreviewclauses-reanalyse">
          {reAnalyseLoader && (
            <Loader
              label="Re-analyzing this document"
              className="metalens-detect-loading"
              fullScreen={false}
            />
          )}
          <div className="metalens-detect-info">
            <span className="metalens-detect-info-icon">
              <FontAwesomeIcon icon={["far", "engine-warning"]} className="" />
            </span>{" "}
            Changes detected. Re-analysing the doc might lose your
            customisation.
          </div>
          <Button
            data-test="documentreviewlisting-btn-reanalyze"
            className="metalens-btn-add-tag metalens-detect-action-btn"
            onClick={() => {
              setReAnalyseLoader(true);
              getDocAnalysisAction(docID, sharingHash)
                .then(() => {
                  setReAnalyseLoader(false);
                })
                .catch(() => {
                  setReAnalyseLoader(false);
                });
            }}
            id="metalens-action-add">
            <FontAwesomeIcon icon={["far", "sync-alt"]} className="" />
            &nbsp; Re-Analyze this doc
          </Button>
        </div>
      )}
      <div
        className={`documentreviewclauses-body ${
          isLatestAnalysis ? "" : "documentreviewclauses-body-fit"
        }`}>
        {currentAnalysis.map((analysisIndex, index) => {
          if (fullAnalysis[analysisIndex]) {
            return (
              <DocumentReviewClauseTag
                setActive={setActiveAnalysisIndex}
                docID={docID}
                sharingHash={sharingHash}
                index={index}
                active={activeAnalysisIndex === index}
                reviewClausesActive={active}
                analysis={fullAnalysis[analysisIndex]}
                key={`${
                  fullAnalysis[analysisIndex].id
                }-document-review-clause-tag`}
              />
            );
          }
          return null;
        })}
        {!(currentAnalysis && currentAnalysis.length) && (
          <div className="documentreviewclauses-empty-image-container">
            <img
              src={emptyImage}
              alt="empty-metatags"
              className="documentreviewclauses-empty-image"
            />
            Sorry, we can’t find any {clauseType.department.toLowerCase()}{" "}
            related clauses for you. You can use the filter to look for any
            specific clause or go back and try a different review.
            <div>
              <Button
                data-test="documentreviewclauses-go-back-btn"
                data-belongsto="metalens-dropdown"
                className="documentreviewclauses-go-back-btn"
                onClick={goBack}
                id="documentreviewclauses-go-back-btn-1">
                Go back
              </Button>
            </div>
          </div>
        )}
      </div>
      {/* Modal */}
      <DocumentReviewClausesFilter
        show={filterModalActive}
        onClose={event => {
          if (event && event.nativeEvent) {
            event.nativeEvent.stopImmediatePropagation();
          }
          setFilterModalActive(false);
        }}
        perClauseAnalysisIndex={perClauseAnalysisIndex}
        currentAnalysis={currentAnalysis}
        applyFilters={_applyFilters}
        getNewFilters={_getNewFilters}
        resetAnalysis={_resetAnalysis}
      />
    </div>
  );
};

const mapStateToProps = ({
  MetalensStore: {
    perDepartmentAnalysisIndex,
    fullAnalysis,
    perClauseAnalysisIndex,
    departmentClauseMapping,
    clauseDepartmentMapping,
    isLatestAnalysis,
  },
  DocumentStore: { document: { id: docID } = {} } = {},
}) => ({
  perDepartmentAnalysisIndex,
  fullAnalysis,
  perClauseAnalysisIndex,
  docID,
  departmentClauseMapping,
  clauseDepartmentMapping,
  isLatestAnalysis,
});

const mapDispatchToProps = {
  getClauseAnalysisMetaAction: getClauseAnalysisMeta,
  getDocAnalysisAction: getDocAnalysis,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DocumentReviewClauses);



// WEBPACK FOOTER //
// ./src/components/QuickReview/DocumentReviewSection/DocumentReviewClauses/DocumentReviewClauses.js